import React from "react";
import { useState } from "react";
import { BiHomeAlt } from "react-icons/bi";
import { IoIosLogOut } from "react-icons/io";
import {
  BsCalendar2Day,
  BsCalendar2Week,
  BsCalendar2Month,
} from "react-icons/bs";
import { FaUsers } from "react-icons/fa";
import CardDaily from "./CardDaily";
import CardWeekly from "./CardWeekly";
import CardMonthly from "./CardMonthly";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CardUsers from "./CardUser";
import DownloadExcel from "./DownloadExcel";

const CustomButton = ({ selected, onClick, children }) => (
  <button
    className={`ml-2 mt-2 flex items-center gap-3 text-[14px] w-full p-2 ${
      selected ? "valid:text-[#0093AD] valid:font-[600]" : ""
    }`}
    onClick={onClick}
  >
    {children}
  </button>
);

export default function Sidebar() {
  const [daily, setDaily] = useState(true);
  const [weekly, setWeekly] = useState(false);
  const [monthly, setMonthly] = useState(false);
  const [users, setUsers] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState([]);
  const router = useNavigate();

  const dailyHandler = async () => {
    setDaily(true);
    setWeekly(false);
    setMonthly(false);
    setUsers(false);
    setSelectedIndex(1);
    await searchType("HARIAN");
  };
  const weeklyHandler = async () => {
    setDaily(false);
    setWeekly(true);
    setMonthly(false);
    setUsers(false);
    setSelectedIndex(2);
    await searchType("MINGGUAN");
  };
  const monthlyHandler = async () => {
    setDaily(false);
    setWeekly(false);
    setMonthly(true);
    setUsers(false);
    setSelectedIndex(3);
    await searchType("BULANAN");
  };
  const usersHandler = async () => {
    setDaily(false);
    setWeekly(false);
    setMonthly(false);
    setUsers(true);
    setSelectedIndex(4);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    router("/");
  };

  const searchType = async (reportType) => {
    try {
      const requestPayload = await axios.get(
        `https://pln-backend.vercel.app/v1/api/find/${reportType}`,
        {
          headers: { "Cache-Control": "no-store" },
        }
      );
      const response = requestPayload.data;
      if (response.status_info) {
        setData(response.data);
      }
    } catch (error) {
      console.log("error");
    }
  };

  return (
    <>
      <div className="mt-28 w-[300px] sidebar overflow-y-auto hidden bg-white rounded-2xl py-4 px-6 shadow-md md:fixed md:block">
        <div>
          <h4 className="text-gray-400">Home</h4>
          <CustomButton onClick={dailyHandler} selected={selectedIndex === 1}>
            <BiHomeAlt />
            Dashboard
          </CustomButton>
          <CustomButton onClick={usersHandler} selected={selectedIndex === 4}>
            <FaUsers />
            Vendor
          </CustomButton>
        </div>
        <div className="mt-4">
          <h4 className="text-gray-400">Kelola Data</h4>
          <CustomButton onClick={dailyHandler} selected={selectedIndex === 1}>
            <BsCalendar2Day />
            Harian
          </CustomButton>
          <CustomButton onClick={weeklyHandler} selected={selectedIndex === 2}>
            <BsCalendar2Week />
            Mingguan
          </CustomButton>
          <CustomButton onClick={monthlyHandler} selected={selectedIndex === 3}>
            <BsCalendar2Month />
            Bulanan
          </CustomButton>
          <DownloadExcel />
        </div>
        <div className="mt-4">
          <h4 className="text-gray-400">Akun</h4>
          <button
            className="ml-2 mt-2 flex items-center justify-between gap-3 rounded-xl px-4 text-[14px] w-full p-2 text-[#FEDDC7] bg-[#F97444] border border-[#FEDDC7]"
            onClick={handleLogout}
          >
            <p>Logout</p>
            <IoIosLogOut />
          </button>
        </div>
      </div>
      <div className="drawer z-50 fixed md:hidden">
        <input id="my-drawer" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content">
          <label
            htmlFor="my-drawer"
            className="drawer-button flex gap-4 items-center absolute top-[10px] left-[15px] cursor-pointer"
          >
            <img
              src="images/logo.png"
              alt=""
              className="w-10 md:w-12 rounded-lg"
            />
            <div className="flex flex-col">
              <p className="text-2xl font-bold text-start">Tivocy</p>
              <span className="text-2xl font-bold text-[12px] text-[#00AEEF]">
                moniTorIng VendOr aCtivitY
              </span>
            </div>
          </label>
        </div>
        <div className="drawer-side">
          <label
            htmlFor="my-drawer"
            aria-label="close sidebar"
            className="drawer-overlay"
          ></label>
          <ul className="menu p-4 w-80 min-h-full bg-base-200 text-base-content">
            <div className="flex gap-4 items-center py-4 pl-4">
              <img src="images/logo.png" alt="" className="w-12 rounded-lg" />
              <div className="flex flex-col">
                <p className="text-2xl font-bold text-start">Tivocy</p>
                <p className="text-2xl font-bold text-[12px] text-[#00AEEF] ">
                  moniTorIng VendOr aCtivitY
                </p>
              </div>
            </div>
            <div className="mt-8 rounded-2xl py-4 px-6">
              <div>
                <h4 className="text-gray-400">Home</h4>
                <CustomButton
                  onClick={dailyHandler}
                  selected={selectedIndex === 1}
                >
                  <BiHomeAlt />
                  Dashboard
                </CustomButton>
                <CustomButton
                  onClick={usersHandler}
                  selected={selectedIndex === 4}
                >
                  <FaUsers />
                  Vendor
                </CustomButton>
              </div>
              <div className="mt-4">
                <h4 className="text-gray-400">Kelola Data</h4>
                <CustomButton
                  onClick={dailyHandler}
                  selected={selectedIndex === 1}
                >
                  <BsCalendar2Day />
                  Harian
                </CustomButton>
                <CustomButton
                  onClick={weeklyHandler}
                  selected={selectedIndex === 2}
                >
                  <BsCalendar2Week />
                  Mingguan
                </CustomButton>
                <CustomButton
                  onClick={monthlyHandler}
                  selected={selectedIndex === 3}
                >
                  <BsCalendar2Month />
                  Bulanan
                </CustomButton>
                <DownloadExcel />
              </div>
              <div className="mt-4">
                <h4 className="text-gray-400">Akun</h4>
                <button
                  className="ml-2 mt-2 flex items-center justify-between gap-3 rounded-xl px-4 text-[14px] w-full p-2 text-[#FEDDC7] bg-[#F97444] border border-[#FEDDC7] "
                  onClick={handleLogout}
                >
                  <p>Logout</p>
                  <IoIosLogOut />
                </button>
              </div>
            </div>
          </ul>
        </div>
      </div>
      {daily && <CardDaily />}
      {weekly && <CardWeekly />}
      {monthly && <CardMonthly />}
      {users && <CardUsers />}
    </>
  );
}
